<mat-dialog-actions [align]="'end'">
  <button matButton (click)="handleClose()" aria-label="Close dialog">
    <mat-icon inline class="x-icon close-icon">close</mat-icon>
  </button>
</mat-dialog-actions>
<app-load-spinner-wrapper [loading]="loading">
  @if (readOnlyMode) {
    <div class="user-mgmt-user-info-modal">
      <h1 class="text-2xl">{{ userDetails?.firstName }} {{ userDetails?.lastName }}</h1>
      @if (userAccountType !== AllAccountTypes.ADMIN && impersonateAllowed && userDetails.userStatusLookupId !== USER_STATUS.DENIED) {
        <a (click)="Impersonate()"
        style="color: blue; text-decoration: underline">Impersonate User</a>
      }
      @if (userDetails.lastLogin) {
        <ng-container *ngTemplateOutlet="lastLoginTemplate;"></ng-container>
      }
      <ng-container *ngTemplateOutlet="personalInfoReadOnlyModeTemplate;"></ng-container>
      @if (userAccountType !== AllAccountTypes.ADMIN) {
        <ng-container *ngTemplateOutlet="companyInfoReadOnlyModeTemplate;"></ng-container>
      }
      @if (userAccountType !== AllAccountTypes.ADMIN && userAccountType !== AllAccountTypes.REFERRAL_PARTNER) {
        <ng-container *ngTemplateOutlet="caseContactReadOnlyModeTemplate;"></ng-container>
      }
      @if (userAccountType === AllAccountTypes.REFERRAL_PARTNER) {
        <ng-container *ngTemplateOutlet="clinicProviderInfoReadOnlyModeTemplate;"></ng-container>
      }
    </div>
    <div mat-dialog-actions class="action-items-container">
      <div>
        @if (userDetails.userStatusLookupId !== USER_STATUS.DENIED) {
          <app-secondary-action-button
            [buttonText]="'Edit User'"
            (clickEmitter)="onEditUser()">
          </app-secondary-action-button>
        }
      </div>
      <div class="flex gap-4">
        @if (userAccountType !== AllAccountTypes.ADMIN) {
          <app-primary-action-button
            [buttonText]="'Delete / Reset MFA'"
            [color]="'#e44c48'"
            (clickEmitter)="onDeleteUser()">
          </app-primary-action-button>
        }
        @if (userDetails.userStatusLookupId === USER_STATUS.ACTIVE) {
          <app-primary-action-button
            [buttonText]="'Suspend'"
            (clickEmitter)="onSuspendUser()">
          </app-primary-action-button>
        }
        @if (userDetails.userStatusLookupId === USER_STATUS.INACTIVE) {
          <app-primary-action-button
            [buttonText]="'Re-Activate'"
            (clickEmitter)="onReactivateUser()">
          </app-primary-action-button>
        }
      </div>
    </div>
  } @else {
    @if (clinicsList.length > 0 && providersList.length > 0) {
      <div class="user-mgmt-user-info-modal">
        <h1 class="text-2xl">{{ userDetails?.firstName }} {{ userDetails?.lastName }}</h1>
        @if (userDetails.lastLogin) {
          <ng-container *ngTemplateOutlet="lastLoginTemplate;"></ng-container>
        }
        <ng-container *ngTemplateOutlet="personalInfoEditModeTemplate;"></ng-container>
        @if (userAccountType !== AllAccountTypes.ADMIN) {
          <ng-container *ngTemplateOutlet="companyInfoEditModeTemplate;"></ng-container>
        }
        @if (userAccountType !== AllAccountTypes.REFERRAL_PARTNER && userAccountType !== AllAccountTypes.ADMIN) {
          <ng-container *ngTemplateOutlet="caseContactEditModeTemplate;"></ng-container>
        }
        @if (userAccountType === AllAccountTypes.REFERRAL_PARTNER) {
          <ng-container *ngTemplateOutlet="clinicProviderInfoEditModeTemplate;"></ng-container>
        }
      </div>
    }
    <div mat-dialog-actions class="action-items-container">
      <app-secondary-action-button
        [buttonText]="'Cancel'"
        (clickEmitter)="onCancel()">
      </app-secondary-action-button>
      <app-primary-action-button
        [buttonText]="'Save'"
        [disabled]="!anyUnsavedChanges"
        (clickEmitter)="onSave()">
      </app-primary-action-button>
    </div>
  }
</app-load-spinner-wrapper>


<ng-template #lastLoginTemplate>
  <div class="mt-4 mb-4">
    <h2 class="text-lg mb-1"><strong>Last Log-In:</strong></h2>
    <hr class="bg-green mb-2" style="height: 2px;"/>
    <p>{{ userDetails.lastLogin | dateFormat }}</p>
  </div>
</ng-template>

<ng-template #personalInfoReadOnlyModeTemplate>
  <div class="mt-4 mb-4">
    <h2 class="text-lg mb-1"><strong>Personal Information:</strong></h2>
    <hr class="bg-green mb-2" style="height: 2px;"/>
    <p>
      <strong>User Type:</strong> {{ userAccountTypeId | accountTypeName }}
    </p>
    <p class="email-address">
      <strong>Email Address:</strong> {{ userDetails?.email }}
    </p>
    @if (userAccountType !== AllAccountTypes.ADMIN) {
      <p>
        <strong>Phone Number:</strong> {{ userDetails.phoneNumber | phoneFormat }}
      </p>
    }
    @if (userAccountType === AllAccountTypes.REFERRAL_PARTNER) {
      <p>
        <strong>Job Title:</strong> {{ toReferralUser(userDetails).jobTitle }}
      </p>
    }
    @if (userAccountType !== AllAccountTypes.REFERRAL_PARTNER && userAccountType !== AllAccountTypes.ADMIN && userDetails?.faxNumber) {
      <p
        >
        <strong>Fax Number:</strong> {{ userDetails.faxNumber | phoneFormat }}
      </p>
    }
    @if (userAccountType !== AllAccountTypes.REFERRAL_PARTNER && userAccountType !== AllAccountTypes.ADMIN) {
      <p>
        <strong>Address:</strong> {{ userDetails?.address }}, {{ userDetails?.city }}
        , {{ userDetails?.state }} {{ userDetails?.postalCode }}
      </p>
    }
  </div>
</ng-template>

<ng-template #companyInfoReadOnlyModeTemplate>
  <div class="mt-4 mb-4">
    <h2 class="text-lg mb-1"><strong>Company Information:</strong></h2>
    <hr class="bg-green mb-2" style="height: 2px;"/>
    <p>
      <strong>Manager's First Name:</strong> {{ toWorkCompUser(userDetails).managerFirstName }}
    </p>
    <p>
      <strong>Manager's Last Name:</strong> {{ toWorkCompUser(userDetails)?.managerLastName }}
    </p>
    <p>
      <strong>Manager's Email Address:</strong> {{ toWorkCompUser(userDetails)?.managerEmail }}
    </p>
    @if (userAccountType !== AllAccountTypes.REFERRAL_PARTNER) {
      <p>
        <strong>Company Name:</strong> {{ toWorkCompUser(userDetails)?.companyName }}
      </p>
    }
    <p>
      <strong>Fax # For Information:</strong> {{ toWorkCompUser(userDetails).faxForInformation | phoneFormat }}
    </p>
    <p>
      <strong>Fax # For Chart Notes:</strong> {{ toWorkCompUser(userDetails).faxForChartNote | phoneFormat }}
    </p>
  </div>
</ng-template>

<ng-template #companyInfoEditModeTemplate>
  <form [formGroup]="companyInfoFormGroup">
    <div class="mt-4">
      <h2 class="text-lg mb-1"><strong>Company Information:</strong></h2>
      <hr class="bg-green mb-2" style="height: 2px;"/>
      <p>
        <strong>Manager's First Name:</strong>
        <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
          <input matInput type="text" formControlName="managerFirstName"/>
          @if (companyInfoFormGroup.get('managerFirstName')?.hasError('required')) {
            <mat-error>
              First Name is required.
            </mat-error>
          }
        </mat-form-field>
      </p>
      <p>
        <strong>Manager's Last Name:</strong>
        <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
          <input matInput type="text" formControlName="managerLastName"/>
          @if (companyInfoFormGroup.get('managerLastName')?.hasError('required')) {
            <mat-error>
              Last Name is required.
            </mat-error>
          }
        </mat-form-field>
      </p>
      <p>
        <strong>Manager's Email Address:</strong>
        <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
          <input matInput type="text" formControlName="managerEmail"/>
          @if (companyInfoFormGroup.get('managerEmail')?.hasError('required')) {
            <mat-error>
              Email is required.
            </mat-error>
          }
          @if (companyInfoFormGroup.get('managerEmail')?.hasError('email')) {
            <mat-error>
              Please enter a valid email.
            </mat-error>
          }
        </mat-form-field>
      </p>
      @if (userAccountType !== AllAccountTypes.REFERRAL_PARTNER) {
        <p>
          <strong>Company Name:</strong>
          <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
            <input matInput type="text" formControlName="companyName"/>
            @if (companyInfoFormGroup.get('companyName')?.hasError('required')) {
              <mat-error>
                Company Name is required.
              </mat-error>
            }
          </mat-form-field>
        </p>
      }
      <p>
        <strong>Fax # For Information:</strong>
        <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
          <input matInput mask="(000) 000-0000" formControlName="faxForInformation"/>
          @if (companyInfoFormGroup.get('faxForInformation')?.hasError('required')) {
            <mat-error>
              Fax number for information is required.
            </mat-error>
          }
          @if (companyInfoFormGroup.get('faxForInformation')?.hasError('mask')) {
            <mat-error>
              Invalid fax number format.
            </mat-error>
          }
        </mat-form-field>
      </p>
      <p>
        <strong>Fax # For Chart Notes:</strong>
        <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
          <input matInput mask="(000) 000-0000" formControlName="faxForChartNote"/>
          @if (companyInfoFormGroup.get('faxForChartNote')?.hasError('required')) {
            <mat-error>
              Fax number for chart note is required.
            </mat-error>
          }
          @if (companyInfoFormGroup.get('faxForChartNote')?.hasError('mask')) {
            <mat-error>
              Invalid fax number format.
            </mat-error>
          }
        </mat-form-field>
      </p>
    </div>
  </form>
</ng-template>


<ng-template #clinicProviderInfoReadOnlyModeTemplate>
  <app-clinic-provider-info-section
    [mode]="'readOnly'"
    [firstClinicProps]="firstClinicProps"
    [secondClinicProps]="secondClinicProps"
    [showPendingSecondClinicRemoval]="false"
    >
  </app-clinic-provider-info-section>
</ng-template>


<ng-template #personalInfoEditModeTemplate>
  <div class="mt-4">
    <h2 class="text-lg mb-1"><strong>Personal Information:</strong></h2>
    <hr class="bg-green mb-2" style="height: 2px;"/>
    <p>
      <strong>User Type:</strong> {{ userAccountTypeId | accountTypeName }}
    </p>
    <p class="mt-4"><strong>Email Address:</strong></p>
    <form [formGroup]="personalInfoForm">
      <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
        <input matInput type="email" formControlName="email"/>
        @if (personalInfoForm.get('email')?.hasError('required')) {
          <mat-error>
            Email is required.
          </mat-error>
        }
        @if (personalInfoForm.get('email')?.hasError('emailTaken')) {
          <mat-error>
            Email is not available.
          </mat-error>
        }
        @if (personalInfoForm.get('email')?.hasError('email') && !personalInfoForm.get('email')?.hasError('required')) {
          <mat-error
            >
            Please enter a valid email address.
          </mat-error>
        }
      </mat-form-field>
      @if (userAccountType !== AllAccountTypes.ADMIN) {
        <p>
          <strong>Phone Number:</strong>
          <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
            <input matInput mask="(000) 000-0000" formControlName="phone"/>
            @if (personalInfoForm.get('phone')?.hasError('required')) {
              <mat-error>
                Phone is required.
              </mat-error>
            }
          </mat-form-field>
        </p>
      }
      @if (userAccountType !== AllAccountTypes.REFERRAL_PARTNER && userAccountType !== AllAccountTypes.ADMIN) {
        <p>
          <strong>Fax Number:</strong>
          <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
            <input matInput mask="(000) 000-0000" formControlName="faxNumber"/>
          </mat-form-field>
        </p>
      }
      @if (userAccountType !== AllAccountTypes.REFERRAL_PARTNER && userAccountType !== AllAccountTypes.ADMIN) {
        <p>
          <strong>Address:</strong>
          <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
            <input matInput type="text" formControlName="address"/>
            @if (personalInfoForm.get('address')?.hasError('required')) {
              <mat-error>
                Address is required.
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
            <input matInput type="text" formControlName="city"/>
            @if (personalInfoForm.get('city')?.hasError('required')) {
              <mat-error>
                City is required.
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
            <mat-select formControlName="state">
              @for (state of us_states_list; track state) {
                <mat-option [value]="state.value">{{state.label}}</mat-option>
              }
            </mat-select>
            @if (personalInfoForm.get('state')?.hasError('required')) {
              <mat-error>
                State is required.
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
            <input
              matInput
              maxlength="5"
              formControlName="zipcode"
              type="text"
              inputmode="numeric"
              pattern="\d*"
              mask="00000"
              >
            @if (personalInfoForm.get('zipcode')?.hasError('required')) {
              <mat-error>
                Zip code is required.
              </mat-error>
            }
            @if (personalInfoForm.get('zipcode')?.hasError('pattern')) {
              <mat-error>
                Zip code must be 5 digits.
              </mat-error>
            }
          </mat-form-field>
        </p>
      }
    </form>
    @if (userAccountType === AllAccountTypes.REFERRAL_PARTNER) {
      <form [formGroup]="referralValues">
        <strong>Job Title:</strong>
        <mat-form-field class="w-full !mt-0 w-full" appearance="outline">
          <input matInput type="text" formControlName="jobTitle"/>
          @if (referralValues.get('jobTitle')?.hasError('required')) {
            <mat-error>
              Job Title is required.
            </mat-error>
          }
        </mat-form-field>
      </form>
    }
  </div>
</ng-template>

<ng-template #caseContactReadOnlyModeTemplate>
  <div class="mt-4 mb-4">
    <h2 class="text-lg mb-1"><strong>NextGen Case Contact:</strong></h2>
    <hr class="bg-green mb-2" style="height: 2px;"/>
    <p>
      {{ selectedCaseContact?.firstName || 'No first name' }} {{ selectedCaseContact?.lastName || 'No last name' }}
      - {{ selectedCaseContact?.email || 'No email' }}
    </p>
  </div>
</ng-template>

<ng-template #caseContactEditModeTemplate>
  <div class="mt-4">
    <h2 class="text-lg mb-1"><strong>NextGen Case Contact:</strong></h2>
    <hr class="bg-green mb-2" style="height: 2px;"/>
    <mat-form-field class="w-full">
      <mat-select
        #caseContactSelect
        placeholder="Select a NextGen Case Contact"
        [value]="selectedCaseContactId"
        (selectionChange)="onCaseContactSelectionChange($event.value)">
        <mat-option>
          <ngx-mat-select-search
            [formControl]="caseContactSearchControl"
            [noEntriesFoundLabel]="noCaseContactsFoundText"
            placeholderLabel="Start typing to find case contact">
          </ngx-mat-select-search>
        </mat-option>
        @for (caseContact of caseContactsList; track caseContact) {
          <mat-option [value]="caseContact.caseContactId">
            {{ caseContact.firstName || 'No first name' }} {{ caseContact.lastName || 'No last name' }}
            - {{ caseContact.email || 'No email' }}
          </mat-option>
        }
        @if (caseContactsList.length === 0) {
          <mat-option [disabled]="true" [value]="null">No contacts available
          </mat-option>
        }
      </mat-select>
      @if (isCaseContactRequiredForSave() && !hasValidCaseContactSelection()) {
        <mat-error>
          A case contact is required
        </mat-error>
      }
    </mat-form-field>
  </div>
</ng-template>


<ng-template #clinicProviderInfoEditModeTemplate>
  <app-clinic-provider-info-section
    [mode]="'edit'"
    [firstClinicProps]="firstClinicProps"
    [secondClinicProps]="secondClinicProps"
    [clinics]="clinicsList"
    [showPendingSecondClinicRemoval]="false"
    [allowSecondProviderRemoval]="true"
    [firstClinicCtrl]="firstClinicCtrl"
    [firstProvidersCtrl]="firstProvidersCtrl"
    [secondClinicCtrl]="secondClinicCtrl"
    [secondProvidersCtrl]="secondProvidersCtrl"
    (firstClinicOtherProviderRemoved)="onFirstClinicOtherProviderRemoved()"
    (secondClinicOtherProviderRemoved)="onSecondClinicOtherProviderRemoved()"
    (firstClinicRemoveRequestRemoved)="onFirstClinicRemovalRequestRemoved()"
    (secondClinicRemoveRequestRemoved)="onSecondClinicRemovalRequestRemoved()"
    >
  </app-clinic-provider-info-section>
</ng-template>
